import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { ON_HOLD_REASONS } from "@constants";
import Modal from "../Modal/Modal";

class HoldReasonModal extends PureComponent {
	constructor(props) {
		super(props);

		this.initialState = {
			holdReason: "1",
			customHoldReason: "",
			showReasonText: false,
			validation: null,
			show: false,
		};

		this.state = { ...this.initialState };

		const { lang } = global;
		const onHoldReasons = ON_HOLD_REASONS.map(({ value, label }) => ({
			value,
			label: lang.t(label),
		}));
		this.onHoldReasons = [...onHoldReasons, { value: "0", label: lang.t("Other") }];
	}

	openModal = () => {
		this.setState({ show: true });
	};

	/**
	 * Confirms that a reason and comments for placing a use on hold have been entered.
	 * If form fields are valid, the hold request is submitted via the `onConfirm` prop
	 */
	onConfirm = () => {
		const { onConfirm } = this.props;

		const { holdReason, customHoldReason } = this.state;

		// reason validation
		if (holdReason === null || (holdReason === "0" && customHoldReason === "")) {
			this.setState({ validation: "has-error" });
			return;
		}

		const reason =
			holdReason === "0"
				? customHoldReason
				: this.onHoldReasons.find(item => item.value.toString() === holdReason).label;

		onConfirm(reason);
		this.resetModal();
	};

	onCancel = () => {
		const { onCancel } = this.props;

		onCancel();
		this.resetModal();
	};

	/**
	 * Handles changes to form values when entering a reason for placing a user on hold
	 * @param {Event} event The HTML event handled by this method
	 */
	handleFormChange = ({ target: { name, value } }) => {
		if (name === "holdReason") {
			this.setState({ showReasonText: value === "0" });
		}

		this.setState({ [name]: value });
	};

	resetModal = () => this.setState(this.initialState);

	render() {
		const { lang } = global;
		const { show, showReasonText, validation, holdReason, customHoldReason } = this.state;

		return (
			<Modal
				show={show}
				onHide={this.onCancel}
				size="sm"
			>
				<Modal.Header>
					<Modal.Title>{lang.t("Put Officer on Hold")}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className={classNames("form-group", validation)}>
						<label
							htmlFor="holdReason"
							className="control-label"
						>
							{lang.t("Please enter a reason why the officer is put on hold")}
						</label>
						<select
							id="holdReason"
							name="holdReason"
							className="form-control"
							value={holdReason}
							onChange={this.handleFormChange}
						>
							<For
								each="option"
								of={this.onHoldReasons}
							>
								<option
									key={option.value}
									value={option.value}
								>
									{option.label}
								</option>
							</For>
						</select>
						<If condition={showReasonText}>
							<div className="margin-top-15">
								<label
									htmlFor="customHoldReason"
									className="control-label"
								>
									{lang.t("Specify the reason")}
								</label>
								<textarea
									name="customHoldReason"
									id="customHoldReason"
									className="form-control"
									rows="3"
									maxLength={128}
									value={customHoldReason}
									onChange={this.handleFormChange}
								/>
							</div>
						</If>
					</div>
					<div className="color-red-torch">
						<i className="rkf rkf-exclamation-triangle margin-right-5" />
						<span>{lang.t("The officer will see this reason")}</span>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button
						type="button"
						className="btn btn-link"
						onClick={this.onCancel}
					>
						{lang.t("Cancel")}
					</button>
					<button
						type="button"
						className="btn btn-primary btn-medium"
						onClick={this.onConfirm}
					>
						{lang.t("Confirm")}
					</button>
				</Modal.Footer>
			</Modal>
		);
	}
}

HoldReasonModal.propTypes = {
	onConfirm: PropTypes.func.isRequired,
	onCancel: PropTypes.func.isRequired,
};

export default HoldReasonModal;
